<template>
  <div class="page container">
    
    <Menu></Menu>
    <h1 class="is-size-4">
      <small class="has-text-weight-bold">Estatísticas</small>
    </h1>
    <table class="table" style="margin:auto">
    <thead>
      <tr>
        <th>Planos Disponivels</th>
        <th>Inscritos</th>
        <th>Valor Unitário</th>
        <th>Valor Total</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Universitário</td>
        <td>20</td>
        <td>200,00</td>
        <td>4000,00</td>
      </tr>
    </tbody>
    <tfoot >
      <tr >
        <th>Total</th>
        <th>20</th>
        <th>200,00</th>
        <th>4000,00</th>
      </tr>
    </tfoot>

  </table>
  </div>  
</template>

<script>
  import Menu from './_menu';

  export default {
    components: {
      Menu
    }
  };
</script>

<style>

</style>